import React, { useRef } from 'react';
import { FieldCheckbox } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { requiredFieldArrayCheckbox } from '../../../util/validators';

import { activities } from '../../../marketplace-custom-config';

import css from '../EditListingDescriptionForm.css';
import { getPrefilledValueFromHorseType } from '../../../components/EditListingWizard/Helpers';
import { EDIT_LISTING_TAB_ACTIVITIES } from '../../../components/EditListingWizard/config';
import { usePrefilledValue } from '../../../components/EditListingWizard/hooks/usePrefilledValue';
import { PrefilledValueTooltip } from '../../../components/EditListingWizard/Components/PrefilledValueTooltip/PrefilledValueTooltip';

const EditListingDescriptionPageFive = ({ form, values }) => {
    const containerRef = useRef();

    const prefilledValues = getPrefilledValueFromHorseType({
        tab: EDIT_LISTING_TAB_ACTIVITIES,
        values,
    });

    const { showPrefilledValue } = usePrefilledValue({
        form,
        fieldName: 'activities',
        prefilledValue: prefilledValues,
    });

    return (
        <>
            <div ref={containerRef}>
                <h1 className={css.horseTypeTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.permittedActivitiesTitle" />
                </h1>
                <p className={css.horseTypeSubTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.permittedActivitiesSubTitle" />
                </p>

                <div>
                    {activities.map(({ key: id, value: label }) => {
                        const isPrefilledValue =
                            showPrefilledValue &&
                            Array.isArray(prefilledValues) &&
                            prefilledValues.includes(id);

                        return (
                            <FieldCheckbox
                                key={id}
                                type="checkbox"
                                id={id}
                                name="activities"
                                label={label}
                                value={id}
                                form={form}
                                validate={requiredFieldArrayCheckbox('Dieses Feld wird benötigt')}
                            >
                                {isPrefilledValue && (
                                    <PrefilledValueTooltip parentContainerRef={containerRef} />
                                )}
                            </FieldCheckbox>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default EditListingDescriptionPageFive;
